<template>
  <div class="gc-list-project-wrap">
    <van-nav-bar :border="false" title="事件"/>

    <van-sticky class="sticky-tab">
      <div class="tab-project-wrap">
        <div
          class="item"
          @click="onTab(0, 1)"
          :class="{ active: activeIndex == 1 }"
        >
          待审核
        </div>
        <div
          class="item"
          @click="onTab(1, 2)"
          :class="{ active: activeIndex == 2 }"
        >
          进行中
        </div>
        <div
          class="item"
          @click="onTab(2, 4)"
          :class="{ active: activeIndex == 4 }"
        >
          待验收
        </div>
        <div
          class="item"
          @click="onTab(3, 5)"
          :class="{ active: activeIndex == 5 }"
        >
          已完成
        </div>
        <div
          class="item"
          @click="onTab('', 0)"
          :class="{ active: activeIndex == 0 }"
        >
          全部
        </div>
      </div>
    </van-sticky>

    <!-- :immediate-check="false" -->
    <ul class="list-project-menu">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad()"
        >
          <router-link
            tag="li"
            v-for="(item, index) in projectList"
            :to="{
              name: 'DetailSatisfaction',
              query: { sysno: item.IncidentSysno }
            }"
            class="item"
            :key="index"
          >
            <div class="title">
              {{ item.IncidentContent }}
              <div class="edit-wrap">
                <div v-if="item.IncidentLevel == 'A'" class="i1 i">
                  {{ item.IncidentLevel }}
                </div>
                <div v-else-if="item.IncidentLevel == 'B'" class="i2 i">
                  {{ item.IncidentLevel }}
                </div>
                <div v-else class="i0 i">{{ item.IncidentLevel }}</div>
              </div>
            </div>
            <div class="info">
              <div v-if="status == -1">
                <p v-if="item.IncidentStatus == 0">
                  <span>事件状态：</span><b class="status1">待审核</b>
                </p>
                <p v-if="item.IncidentStatus == 1">
                  <span>事件状态：</span><b class="status1">进行中</b>
                </p>
                <p v-if="item.IncidentStatus == 2">
                  <span>事件状态：</span><b class="status1">待验收</b>
                </p>
                <p v-if="item.IncidentStatus == 3">
                  <span>事件状态：</span><b class="status1">已完成</b>
                </p>
              </div>
              <!-- <p><span>事件内容：</span>{{item.IncidentContent}}</p> -->
              <p><span>事件创建时间：</span>{{ item.CreateTime }}</p>
              <p><span>事件截止时间：</span>{{ item.EndTime }}</p>
              <p>
                <span>处理人：</span
                >{{ item.DealUserName + "-" + item.DealUserDepName }}
              </p>
              <p><span>业务人员：</span>{{ item.UserName }}</p>
              <p><span>处理要求：</span>{{ item.IncidentRequire }}</p>
            </div>
          </router-link>
        </van-list>
      </van-pull-refresh>
    </ul>

    <router-link class="add-btn" :to="{ name: 'AddSatisfaction' }"
    ><img class="img" src="@/assets/addPlus.png"
    /></router-link>
  </div>
</template>

<script>
var isKeepAlive = false; //是否保持缓存状态
var isClick = false; //是否是tab点击
export default {
  data() {
    return {
      activeIndex: 1,
      status: 0,
      projectList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pcount: 10,
      allcount: 0,
      isReview: localStorage.getItem("ReponseLog"),

      activeType: 2, //1我参与的项目（验收、创建、执行）；2我出资的项目
      uid: localStorage.getItem("UserSysno")
    };
  },
  mounted() {
    // this.WebGetIncidentLst(this.status);
  },
  watch: {
    $route(to, from) {
      console.log(from);
      if (from.name == "DetailSatisfaction" || from.name == "AddSatisfaction") {
        this.onRefresh();
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from);
    if (from.name == "DetailSatisfaction") {
      // to.meta.keepAlive = true;
      isKeepAlive = true;
      isClick = false;
    } else {
      // to.meta.keepAlive = false;
      isKeepAlive = false;
    }
    next();
  },
  // 离开
  deactivated() {
    console.log("deactivated");
  },
  // 进入
  activated() {
    console.log("activated");
    // this.onRefresh();
  },
  methods: {
    onLoad() {
      console.log("onLoad");
      this.WebGetIncidentLst(this.status);
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.projectList = [];
      this.onLoad();
    },
    WebGetIncidentLst(status) {
      let data = {
        QDetail: localStorage.getItem("IsSatis") || 0,
        UserSysno: localStorage.getItem("UserSysno"),
        StatusKey: status,
        page: this.page,
        pcount: this.pcount
      };
      if (localStorage.getItem("isBoss") == 1) {
        data = {
          QDetail: 1,
          StatusKey: status,
          page: this.page,
          pcount: this.pcount
        };
      }
      this.$baseajax.normalJsonp(
        this.$base.baseEvent + "/WebGetIncidentLst",
        data,
        res => {
          console.log(res);

          if (this.refreshing) {
            this.refreshing = false;
          }
          this.loading = false;

          res = res.WebGetIncidentLstResult;
          if (res.ResponseCode == 1) {
            this.allcount = res.AllCount;
            if (res.ItemLst) {
              this.projectList.push(...res.ItemLst);
            }
            if (this.projectList.length >= this.allcount) {
              this.finished = true;
            } else {
              this.page++;
            }

            // 位置保存 如果是详情返回的记录保存位置
            setTimeout(() => {
              // console.log(window.targetPosition);
              if (window.targetPosition && isKeepAlive && !isClick) {
                window.scrollTo(
                  window.targetPosition.x,
                  window.targetPosition.y
                );
              }
            }, 0);
          } else {
            this.finished = true;
          }
        },
        err => {
        }
      );
    },
    onTab(status, index) {
      this.activeIndex = index;
      this.status = status;
      isClick = true;
      this.onRefresh();
    },
    onTabType(i) {
      this.activeType = i;
      isClick = true;
      this.onRefresh();
    },
    handleEdit(sysno) {
      this.$router.push({
        name: "AddSatisfaction",
        query: {
          sysno: sysno
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/base.less";

/deep/ .van-tab {
  font-size: 0.4rem;
}

.add-btn {
  position: fixed;
  bottom: 2.2rem;
  right: 0.4rem;

  .img {
    width: 1.5rem;
    height: 1.5rem;
  }
}

.tab-income-outgo-wrap {
  display: flex;
  background: #f6f6f6;
  height: 1.2rem;
  line-height: 1.2rem;
  padding: 0 0.28rem;

  .item {
    width: 3rem;
    font-size: 0.42rem;
    color: #333;

    &.active {
      color: @color;
    }
  }
}

.tab-project-wrap {
  box-shadow: none;
}

.sticky-tab {
  box-shadow: 0rem 0.01rem 0.13rem 0rem rgb(42 48 158 / 11%);
}

.gc-list-project-wrap {
  padding-bottom: 1.6rem;
}

.list-project-menu {
  margin: 0.28rem 0.28rem 0;
  padding: 0 0.48rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .item {
    padding: 0.5rem 0;
    border-top: 1px solid #ddd;

    &:first-child {
      border-top: none;
    }

    .title {
      font-size: 0.4rem;
      font-weight: 700;
      color: #333333;
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.3rem;

      .edit-wrap {
        display: flex;

        .edit-bt {
          margin-left: 0.2rem;
          flex: 0 0 0.48rem;
        }

        .i {
          width: 0.56rem;
          height: 0.56rem;
          line-height: 0.56rem;
          background: #f9c351;
          border-radius: 100%;
          text-align: center;
          font-size: 0.3rem;
          font-weight: normal;
          color: #fff;

          &.i1 {
            background: #f13924;
          }

          &.i2 {
            background: #f17d24;
          }
        }
      }

      i {
        flex: 0 0 0.48rem;
        margin-left: 0.2rem;
        width: 0.48rem;
        height: 0.48rem;
        background-size: contain;

        &.i0 {
          background-image: url("~@/assets/more.png");
        }

        &.i1 {
          background-image: url("~@/assets/join.png");
        }

        &.i2 {
          background-image: url("~@/assets/more.png");
        }

        &.i3 {
          background-image: url("~@/assets/ing.png");
        }

        &.i4 {
          background-image: url("~@/assets/finished.png");
        }
      }
    }

    .info {
      font-size: 0.3rem;
      color: #888888;

      p {
        margin-top: 0.08rem;
      }

      span {
        font-size: 0.32rem;
        color: #666666;
      }

      b {
        font-weight: normal;

        &.status1 {
          color: #0090ff; //待参与
        }

        &.status2 {
          color: #B71C1C; //待审核
        }

        &.status3 {
          color: #D32F2F; //执行中
        }

        &.status4 {
          color: #9ee355; //已完成
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/satisfaction/Index.vue